// src/services/library/loan.ts
import { LOAN } from "../../utils/constants";
import { get, post, put } from "../../utils/axios-config";
import { LoanType } from "../../types/Library";
import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";

export const createLoan = async (data: LoanType) => await post(LOAN, data);

export const updateLoan = async (data: LoanType) => await put(LOAN, data);

export const getLoans = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || "1",
        PageSize: data?.PageSize?.toString() || "10",
    });
    const url = `${LOAN}?${queryParams.toString()}`;
    return await get<PagedResultsType<LoanType>>(url);
};
